const header = document.querySelector('[data-js-module="o-header"]');

const init = async () => {
  const { default: Header } = await import(/* webpackChunkName: "o-header" */ './header.jsx');

  Header(header);
};

if (header) init();
